const LowerSection = () => {
  return (
    <section className="lower-section">
      <article className="lower-section-info flex-col flex-col-ai-c">
        <div className="title">
          <h1>Find out more about how we work</h1>
        </div>
        <button>HOW WE WORK</button>
      </article>
    </section>
  );
};

export default LowerSection;
